export const categories = [
  {
    slug: 'tv-series',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '海量热播电视剧，涵盖都市情感、古装玄幻、悬疑探案等多元题材',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20modern%20living%20room%20with%20a%20large%20television%20screen%20displaying%20a%20Chinese%20drama%20scene%2C%20warm%20ambient%20lighting%2C%20comfortable%20sofa%2C%20shelf%20with%20decorative%20items%2C%20cinematic%20mood%2C%20soft%20warm%20tones%2C%20clean%20aesthetic%2C%20editorial%20photography%20with%20shallow%20depth%20of%20field&width=600&height=400&seq=cat-tv-01&orientation=landscape',
  },
  {
    slug: 'movies',
    name: '电影',
    icon: 'ri-film-line',
    description: '精选国内外高分电影，动作大片、温情喜剧、经典文艺片一网打尽',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20home%20theater%20setup%20with%20a%20large%20projector%20screen%20showing%20an%20artistic%20film%20still%2C%20plush%20red%20velvet%20seats%2C%20dim%20warm%20lighting%2C%20popcorn%20on%20a%20side%20table%2C%20elegant%20interior%2C%20movie%20night%20atmosphere%2C%20soft%20glow%2C%20editorial%20photography&width=600&height=400&seq=cat-movie-02&orientation=landscape',
  },
  {
    slug: 'variety',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '热门综艺节目全覆盖，音乐竞演、真人秀、脱口秀、旅行节目应有尽有',
    image: 'https://readdy.ai/api/search-image?query=A%20bright%20and%20vibrant%20television%20studio%20set%20with%20colorful%20stage%20lighting%2C%20variety%20show%20atmosphere%2C%20modern%20broadcast%20equipment%2C%20cheerful%20ambiance%2C%20warm%20stage%20lights%20in%20golden%20and%20coral%20tones%2C%20clean%20composition%2C%20editorial%20photography&width=600&height=400&seq=cat-variety-03&orientation=landscape',
  },
  {
    slug: 'anime',
    name: '动漫',
    icon: 'ri-gamepad-line',
    description: '正版授权动漫资源库，热血番、治愈番、国创精品持续更新中',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20desk%20setup%20with%20a%20large%20monitor%20displaying%20colorful%20anime%20style%20art%2C%20surrounded%20by%20art%20supplies%20and%20figures%2C%20warm%20natural%20light%20from%20a%20window%2C%20creative%20workspace%20vibe%2C%20soft%20pastel%20accents%2C%20clean%20aesthetic%2C%20editorial%20photography&width=600&height=400&seq=cat-anime-04&orientation=landscape',
  },
  {
    slug: 'documentary',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: '高品质纪录片频道，自然探索、历史人文、科技前沿精彩呈现',
    image: 'https://readdy.ai/api/search-image?query=A%20serene%20reading%20nook%20with%20a%20tablet%20showing%20nature%20documentary%20footage%2C%20surrounded%20by%20books%20about%20world%20cultures%20and%20nature%2C%20warm%20sunlight%20streaming%20through%20a%20window%2C%20wooden%20furniture%2C%20earthy%20tones%2C%20intellectual%20yet%20cozy%20atmosphere%2C%20editorial%20photography&width=600&height=400&seq=cat-doc-05&orientation=landscape',
  },
  {
    slug: 'kids',
    name: '少儿',
    icon: 'ri-heart-line',
    description: '安全绿色的儿童内容专区，启蒙教育、趣味动画陪伴孩子健康成长',
    image: 'https://readdy.ai/api/search-image?query=A%20bright%20and%20playful%20children%20playroom%20with%20a%20tablet%20on%20a%20colorful%20rug%20showing%20educational%20animation%2C%20soft%20toys%20scattered%20around%2C%20warm%20natural%20light%2C%20pastel%20color%20palette%2C%20safe%20and%20inviting%20atmosphere%2C%20editorial%20photography%20with%20soft%20focus&width=600&height=400&seq=cat-kids-06&orientation=landscape',
  },
];

export const featuredContent = [
  {
    id: 1,
    title: '长安十二时辰·续',
    category: '电视剧',
    rating: 9.2,
    description: '延续前作恢弘格局，讲述大唐盛世下的权谋与侠义传奇，全新阵容带来更震撼的视觉体验。',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20of%20ancient%20Chinese%20Tang%20dynasty%20city%20at%20night%20with%20lanterns%20and%20traditional%20architecture%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20warm%20golden%20and%20red%20tones%2C%20movie%20poster%20style%20composition%2C%20atmospheric%20fog%2C%20high%20production%20value%20aesthetic&width=800&height=500&seq=feat-01&orientation=landscape',
  },
  {
    id: 2,
    title: '深海迷踪',
    category: '电影',
    rating: 8.8,
    description: '科幻悬疑巨制，一支深海科考队在万米海沟发现未知文明遗迹，真相令人震惊。',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20deep%20ocean%20scene%20with%20bioluminescent%20creatures%20and%20ancient%20underwater%20ruins%2C%20submarine%20exploring%20the%20depths%2C%20dark%20blue%20and%20teal%20color%20palette%2C%20cinematic%20sci-fi%20atmosphere%2C%20dramatic%20lighting%20from%20submersible%20beams%2C%20epic%20movie%20poster%20style&width=800&height=500&seq=feat-02&orientation=landscape',
  },
  {
    id: 3,
    title: '声入人心·第四季',
    category: '综艺',
    rating: 9.0,
    description: '经典音乐竞技综艺回归，全新赛制升级，顶级唱将集结，用歌声打动每一颗心。',
    image: 'https://readdy.ai/api/search-image?query=A%20grand%20music%20concert%20stage%20with%20dramatic%20spotlights%20in%20warm%20golden%20and%20coral%20colors%2C%20a%20singer%20in%20silhouette%20with%20a%20microphone%2C%20orchestra%20in%20the%20background%2C%20grand%20theater%20setting%2C%20emotional%20atmosphere%2C%20cinematic%20lighting%2C%20high-end%20production%20aesthetic&width=800&height=500&seq=feat-03&orientation=landscape',
  },
  {
    id: 4,
    title: '星海征途',
    category: '动漫',
    rating: 9.5,
    description: '国产科幻动漫巅峰之作，人类星际移民时代的冒险故事，画面惊艳全球动漫爱好者。',
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20sci-fi%20space%20scene%20with%20a%20futuristic%20spaceship%20approaching%20a%20colorful%20nebula%2C%20distant%20planets%2C%20stars%2C%20anime-inspired%20art%20style%2C%20vibrant%20purple%20and%20blue%20cosmic%20colors%2C%20epic%20cinematic%20composition%2C%20high%20detail%20digital%20art&width=800&height=500&seq=feat-04&orientation=landscape',
  },
];

export const latestArticles = [
  {
    id: 1,
    title: '红桃视频2026年暑期档片单公布，多部重磅作品即将上线',
    summary: '涵盖电视剧、电影、综艺、动漫四大板块，十余部独家内容蓄势待发，为观众带来一场视听盛宴。',
    category: '平台公告',
    date: '2026-08-05',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20entertainment%20company%20press%20conference%20scene%20with%20large%20screens%20displaying%20movie%20posters%2C%20journalists%20and%20cameras%2C%20professional%20lighting%2C%20warm%20atmosphere%2C%20corporate%20event%20aesthetic%2C%20clean%20composition%2C%20editorial%20photography&width=600&height=350&seq=article-01&orientation=landscape',
  },
  {
    id: 2,
    title: '如何选择最适合自己的视频会员套餐？这份指南请收好',
    summary: '从观看习惯、设备数量、内容偏好等角度出发，帮你找到性价比最高的会员方案。',
    category: '使用攻略',
    date: '2026-08-03',
    image: 'https://readdy.ai/api/search-image?query=A%20person%20comfortably%20sitting%20on%20a%20modern%20sofa%20using%20a%20tablet%20to%20browse%20streaming%20options%2C%20warm%20living%20room%20setting%2C%20soft%20natural%20light%2C%20cozy%20minimalist%20interior%2C%20lifestyle%20photography%2C%20relaxed%20mood%2C%20clean%20aesthetic&width=600&height=350&seq=article-02&orientation=landscape',
  },
  {
    id: 3,
    title: '红桃视频VIP会员专属福利全面升级，四大权益等你来享',
    summary: '4K超清画质、多端同步观看、专属客服通道、线下活动优先参与权，会员体验再上新台阶。',
    category: '会员福利',
    date: '2026-07-28',
    image: 'https://readdy.ai/api/search-image?query=A%20luxurious%20golden%20VIP%20membership%20card%20on%20a%20dark%20elegant%20surface%20with%20soft%20bokeh%20lights%20in%20the%20background%2C%20premium%20and%20exclusive%20feel%2C%20warm%20golden%20and%20black%20color%20scheme%2C%20high-end%20product%20photography%2C%20sophisticated%20composition&width=600&height=350&seq=article-03&orientation=landscape',
  },
  {
    id: 4,
    title: '红桃视频技术团队：AI智能推荐系统如何精准匹配你的口味',
    summary: '深度揭秘平台背后的人工智能算法，如何通过大数据分析为每位用户提供个性化内容推荐。',
    category: '技术揭秘',
    date: '2026-07-20',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20tech%20office%20with%20large%20monitors%20displaying%20data%20analytics%20and%20AI%20dashboards%2C%20clean%20minimalist%20workspace%2C%20warm%20ambient%20lighting%2C%20professional%20yet%20creative%20atmosphere%2C%20software%20engineering%20aesthetic%2C%20editorial%20photography&width=600&height=350&seq=article-04&orientation=landscape',
  },
  {
    id: 5,
    title: '红桃视频与多家国际影视公司达成战略合作，内容生态再升级',
    summary: '引入更多海外优质版权内容，为用户打造全球化视野的影视娱乐平台。',
    category: '平台动态',
    date: '2026-07-15',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20corporate%20boardroom%20with%20executives%20shaking%20hands%20over%20a%20contract%2C%20large%20windows%20with%20city%20view%2C%20professional%20business%20setting%2C%20warm%20natural%20light%2C%20partnership%20and%20collaboration%20theme%2C%20clean%20corporate%20aesthetic%2C%20editorial%20photography&width=600&height=350&seq=article-05&orientation=landscape',
  },
  {
    id: 6,
    title: '观影体验大提升：红桃视频全面支持杜比全景声与HDR10+',
    summary: '技术升级带来沉浸式观影新体验，在家也能享受影院级的视听效果。',
    category: '技术升级',
    date: '2026-07-08',
    image: 'https://readdy.ai/api/search-image?query=A%20high-end%20home%20theater%20setup%20with%20a%20large%20OLED%20TV%2C%20surround%20sound%20speakers%2C%20dim%20ambient%20lighting%2C%20luxurious%20modern%20interior%2C%20cinematic%20experience%20at%20home%2C%20warm%20indirect%20lighting%2C%20premium%20entertainment%20setup%2C%20editorial%20photography&width=600&height=350&seq=article-06&orientation=landscape',
  },
];

export const memberPlans = [
  {
    name: '月卡会员',
    price: '25',
    period: '月',
    originalPrice: '30',
    features: ['高清画质观看', '免广告打扰', '每月5部点播券', '单设备观看'],
    highlighted: false,
  },
  {
    name: '季卡会员',
    price: '68',
    period: '季',
    originalPrice: '90',
    features: ['超清4K画质', '免广告打扰', '每月10部点播券', '双设备同时观看', '专属客服通道'],
    highlighted: false,
  },
  {
    name: '年卡会员',
    price: '238',
    period: '年',
    originalPrice: '360',
    features: ['超清4K画质 + HDR', '免广告打扰', '无限点播券', '四设备同时观看', '专属客服通道', '线下活动优先参与', '生日专属礼包'],
    highlighted: true,
  },
];

export const faqItems = [
  {
    question: '红桃视频支持哪些设备观看？',
    answer: '红桃视频支持手机（iOS/Android）、平板电脑、电脑网页端、智能电视（包括小米电视、海信电视、创维电视等主流品牌）及电视盒子等多种设备。一个账号可在多个设备上登录使用，会员套餐根据等级支持不同数量的同时在线设备。',
  },
  {
    question: '会员到期后会自动续费吗？',
    answer: '红桃视频提供灵活的订阅方式。您可以在购买时选择是否开启自动续费功能。如果开启了自动续费，会员到期前系统会自动从您的支付账户扣款续费；如未开启，到期后会员权益将自动终止，不会产生额外费用。您可以随时在账户设置中管理自动续费状态。',
  },
  {
    question: '如何申请退款？',
    answer: '如果您在购买会员后7天内且观看内容不超过5小时，可以通过红桃视频App或官网的联系客服渠道申请全额退款。超过7天或观看时长超过5小时的订单，我们将根据实际情况酌情处理。退款将在审核通过后的3-7个工作日内原路返回您的支付账户。',
  },
  {
    question: '红桃视频的内容是否为正版？',
    answer: '红桃视频始终坚持正版化运营，平台所有影视内容均已获得正规版权授权。我们与国内外数百家影视制作公司、发行方建立了长期合作关系，确保每一部作品都经过合法授权。选择红桃视频，就是选择正版，支持优质内容创作。',
  },
  {
    question: '红桃视频的4K画质需要什么网络条件？',
    answer: '观看4K超清画质内容建议网络带宽在25Mbps以上。如果您的网络条件暂时不满足要求，系统会自动为您匹配最适合当前网络环境的画质，确保流畅观看体验。您也可以在播放设置中手动调整画质选项。',
  },
  {
    question: '可以在国外使用红桃视频吗？',
    answer: '红桃视频目前主要服务于中国大陆地区用户。部分内容因版权限制，在境外可能无法正常播放。我们正在积极推进海外版权合作，未来将逐步扩大服务覆盖范围。如果您在境外有观看需求，建议关注我们的国际版进展。',
  },
];